import { ComponentRoute } from '@/classes'

const AuditTrailRoutes = {
  AuditTrailListView: new ComponentRoute('/audittrail', 'AuditTrailListView'),
  AuditTrailView: new ComponentRoute('/audittrail/:auditTrailFieldId', 'AuditTrailView'),
  AuditTrailDetail: new ComponentRoute('/audittrail/:auditTrailFieldId', 'AuditTrailDetail')
}

export default AuditTrailRoutes